import request from "@/utils/request.js";
import { WeeklyActivity } from "./config.js";
import _ from "lodash";

/**
 * 根据碎片id获取碎片详情
 * @param {*} params
 */
export const getTaskReward = () => {
  return request.get(WeeklyActivity.reward_list);
};

/**
 * 提取等级奖励
 * @param {*} params
 */
 export const postRewardClaim = (params) => {
    return request.post(WeeklyActivity.reward_claim, params);
  };

/**
 * 提取经验
 * @param {*} params
 */
export const postExpClaim = (params) => {
  return request.post(WeeklyActivity.exp_claim, params);
};

/**
 * 活跃任务升级
 */
export const postUpgrade = () => {
  return request.post(WeeklyActivity.upgrade, {});
};

/**
 * 获取og列表
 */
export const getOgList = () => {
  return request.get(WeeklyActivity.og_list);
}

/**
 * 提取og等级奖励
 * @param {*} params
 */
export const postOgRewardClaim = (params = {}) => {
  return request.post(WeeklyActivity.og_reward_claim, params);
};